import Modal from "../../Unknown/Modal";
import { useAppDispatch, useAppSelector } from "../../../modules/store/hooks";
import { modalsSlice } from "../../../modules/store/reducers/modalsSlice";
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import translate from "../../../i18n/translate";
import { useIntl } from "react-intl";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { useState } from "react";
import { organizerApi } from "../../../modules/services/organizerService";
import toast from "react-hot-toast";

export default function CancelTicketModal() {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const { toggleCancelTicketModal } = modalsSlice.actions;
  const visible = useAppSelector((state) => state.modalsReducer.cancelTicket);

  const [view, setView] = useState('search');
  const [guestData, setGuestData] = useState<any>({
    count: 0,
    list: [],
  });
  const [guestDetails, setGuestDetails] = useState<any>({
    count: 0,
    list: [],
  });
  const [phone, setPhone] = useState<string | null>(null);
  const [eventLink, setEventLink] = useState<string | null>(null);
  const [ids, setIds] = useState<number[]>([]);
  const [returnMoney, setReturnMoney] = useState<boolean>(false);
  const [sendSms, setSendSms] = useState<boolean>(false);
  const [generateDocs, setGenerateDocs] = useState<boolean>(false);
  const [fullReturn, setFullReturn] = useState<boolean>(false);
  const [isConfirmOverdraftCancel, setIsConfirmOverdraftCancel] = useState<boolean>(false);

  const [handleGuestListSearch, { isLoading }] = organizerApi.useGetGuestListSearchMutation()

  const onCloseModal = () => {
    setView('search');
    setGuestData({
      count: 0,
      list: [],
    });
    setGuestDetails({
      count: 0,
      list: [],
    });
    setPhone(null);
    setEventLink(null);
    setIds([]);
    setReturnMoney(false);
    setSendSms(false);
    setGenerateDocs(false);
    setFullReturn(false);
    setIsConfirmOverdraftCancel(false);
    dispatch(toggleCancelTicketModal());
  }

  const [cancelTicket] = organizerApi.useCancelTicketMutation();

  const handleSearch = async () => {
    try {
      if (phone && eventLink) {
        const response: any =  await handleGuestListSearch({ phone, eventLink });

        setGuestData(response?.data);

        setView('list');
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  }

  const handleChangeTickets = async () => {
    try {
      const res = await cancelTicket({
        sessionId: guestDetails?.list?.[0]?.sessionId,
        ids,
        returnMoney,
        sendSms,
        yeshInvoiceDocs: generateDocs,
        fullReturn,
      }) as any

      if (res?.data?.message || res?.data?.status === 400) {
        toast.error(res?.data?.message || 'error');
      } else {
        toast.success(translate("ticketChangedSuccess"));
        
        onCloseModal();
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  }

  const handleBack = () => {
    setGuestData({
      count: 0,
      list: [],
    });
    setView('search');
  }

  const handleBackToList = () => {
    setGuestDetails({
      count: 0,
      list: [],
    });
    setView('list');
  }

  const handleSelect = async (sessionId: string) => {
    try {
      const response: any = await dispatch(organizerApi.endpoints.getGuestDetails.initiate({ sessionId }));

      setGuestDetails(response?.data);

      setIds([]);
      setReturnMoney(false);
      setSendSms(false);
      setGenerateDocs(false);
      setFullReturn(false);
      setIsConfirmOverdraftCancel(false);
      setView('item');
    } catch (error: any) {
      toast.error(error?.message);
    }
  }

  const handleSelectId = (id: number) => {
    setIds((prev) => {
      if (prev.includes(id)) {
        return prev.filter((i) => i !== id)
      }

      return [...prev, id]
    })
  }

  const handleSelectAll = () => {
    setIds((prev) => {
      if (prev.length === guestDetails.count) {
        return [];
      }

      return guestDetails?.list?.map?.((i: any) => i.id) || [];
    })
  }

  const searchView = () => {
    return (
      <Box my={2} p={2} display="flex" flexDirection="column" justifyContent="center" width={1} alignItems="center" gap={2}>
        <TextField 
          variant='outlined'
          disabled={isLoading}
          fullWidth
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder={intl.formatMessage({ id: "phoneNumberPlaceholder" })}
          dir="ltr"
          sx={{
            '.MuiInputBase-root.MuiInput-root:before':{
              borderBottom: "0px"
            },
            '.MuiInputBase-root.MuiInput-root:hover':{
              borderBottom: "0px"
            },
          }}
        />
        <TextField 
          variant='outlined'
          disabled={isLoading}
          fullWidth
          value={eventLink}
          onChange={(e) => setEventLink(e.target.value)}
          placeholder={intl.formatMessage({ id: "eventLinkPlaceholder" })}
          dir="ltr"
          sx={{
            '.MuiInputBase-root.MuiInput-root:before':{
              borderBottom: "0px"
            },
            '.MuiInputBase-root.MuiInput-root:hover':{
              borderBottom: "0px"
            },
          }}
        />
        
        <Button
          size="large"
          variant="contained"
          color="warning"
          fullWidth
          onClick={handleSearch}
          disabled={!phone || !eventLink || isLoading}
          >
          {translate("searchTickets")}
        </Button>
      </Box>
    );
  };

  const listView = () => {
    return (
      <Box my={2} p={2} display="flex" flexDirection="column" justifyContent="center" width={1} alignItems="center" gap={2}>
        <Box display="flex" flexDirection="column" gap={1} width={1}>
          {guestData?.list?.map((item: any) => (
            <Box 
              border='1px solid #ed6c02'
              borderRadius={2}
              p={1}
              width={1}
              key={item.id}
              display="flex"
              flexDirection="column"
              gap={0.25}
              onClick={() => handleSelect(item?.sessionId)}
              sx={{ 
                ":hover": {
                  cursor: 'pointer',
                  borderColor: 'orange',
                  background: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <Box display='flex' gap={0.5} width={1}>
                <Box width={1 / 2} display="flex" flexDirection="column" justifyContent="center">
                  <Typography variant='body2' align="center">{translate("buyerUser")}</Typography>
                  <Typography variant='body2'>{item?.buyerUser?.name} {item?.buyerUser?.surname}</Typography>
                  <Typography variant='body2'>{item?.buyerUser?.phone}</Typography>
                </Box>
                <Box width={1 / 2} display="flex" flexDirection="column" justifyContent="center">
                  <Typography variant='body2' align="center">{translate("ticketUser")}</Typography>
                  <Typography variant='body2'>{item?.guestUser?.name} {item?.guestUser?.surname}</Typography>
                  <Typography variant='body2'>{item?.guestUser?.phone}</Typography>
                </Box>
              </Box>
              <Box display='flex' flexDirection="column" gap={0.5} width={1}>
                <Typography variant='body2' align="center">{translate("ticketInfo")}</Typography>
                <Box display='flex' gap={0.5} width={1}>
                  <Box width={1 / 2} display="flex" flexDirection="column" justifyContent="center">
                    <Typography variant='body2'>{translate("price")}: <b>{item?.price}</b></Typography>
                    <Typography variant='body2'>{translate("feePrice")}: <b>{item?.feePrice}</b></Typography>
                  </Box>
                  <Box width={1 / 2} display="flex" flexDirection="column" justifyContent="center">
                    <Typography variant='body2'>{translate("cardHolder")}: <b>{item?.paymentInfo?.paymentCardHolder}</b></Typography>
                    <Typography variant='body2'>{translate("cardNumber")}: <b>{item?.paymentInfo?.formattedCardNumber}</b></Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
        <Button
          size="large"
          variant="contained"
          color="warning"
          fullWidth
          onClick={handleBack}
        >
          {translate("backToSearch")}
        </Button>
      </Box>
    );
  };

  const itemView = () => {
    return (
      <Box my={2} p={2} display="flex" flexDirection="column" justifyContent="center" width={1} alignItems="center" gap={1}>
        <Box display="flex" flexDirection="column" gap={1} width={1}>
          <Box 
            border='1px solid #ed6c02'
            borderRadius={2}
            p={1}
            width={1}
            display="flex"
            flexDirection="column"
            gap={0.25}
          >
            <Typography variant='body2' align="center">{translate("buyerUser")}</Typography>
            <Typography variant='body2'>{guestDetails?.list?.[0]?.buyerUser?.name} {guestDetails?.list?.[0]?.buyerUser?.surname}</Typography>
            <Typography variant='body2'>{guestDetails?.list?.[0]?.buyerUser?.phone}</Typography>
          </Box>
          <Button 
            sx={{
              color: "#fc7f04",
              width: '100%',
              display: 'flex',
              lineHeight: 1,
              alignItems: 'center',
              justifyContent: 'flex-start',
            }}
            onClick={handleSelectAll}
            startIcon={
              guestDetails.count === ids?.length 
              ? <CheckBoxIcon style={{ marginRight: "10px" }}/>
              : <CheckBoxOutlineBlankIcon style={{ marginRight: "10px" }}/>
            }
          >
            {translate("selectAll")}
          </Button>
          {guestDetails?.list?.map((item: any) => (
            <Box 
              border={ids.includes(item.id) ? '1px solid #ff9100' : '1px solid #ed6c02'}
              bgcolor={ids.includes(item.id) ? '#ffcfa7' : ''}
              borderRadius={2}
              p={1}
              width={1}
              key={item.id}
              display="flex"
              flexDirection="column"
              gap={0.25}
              onClick={() => handleSelectId(item?.id)}
              sx={{ 
                ":hover": {
                  cursor: 'pointer',
                  borderColor: 'orange',
                  background: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <Box display='flex' gap={0.5} width={1}>
                <Box width={1} display="flex" flexDirection="column" justifyContent="center">
                  <Typography variant='body2' align="center">{translate("ticketUser")}</Typography>
                  <Typography variant='body2'>{item?.guestUser?.name} {item?.guestUser?.surname}</Typography>
                  <Typography variant='body2'>{item?.guestUser?.phone}</Typography>
                </Box>
              </Box>
              <Box display='flex' flexDirection="column" gap={0.5} width={1}>
                <Typography variant='body2' align="center">{translate("ticketInfo")}</Typography>
                <Box display='flex' gap={0.5} width={1}>
                  <Box width={1 / 2} display="flex" flexDirection="column" justifyContent="center">
                    <Typography variant='body2'>{translate("price")}: <b>{item?.price}</b></Typography>
                    <Typography variant='body2'>{translate("feePrice")}: <b>{item?.feePrice}</b></Typography>
                  </Box>
                  <Box width={1 / 2} display="flex" flexDirection="column" justifyContent="center">
                    <Typography variant='body2'>{translate("cardHolder")}: <b>{item?.paymentInfo?.paymentCardHolder}</b></Typography>
                    <Typography variant='body2'>{translate("cardNumber")}: <b>{item?.paymentInfo?.formattedCardNumber}</b></Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
        <Button 
          sx={{
            color: "#fc7f04",
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            lineHeight: 1,
          }}
          disabled
          startIcon={
            true 
            ? <CheckBoxIcon style={{ marginRight: "10px" }}/>
            : <CheckBoxOutlineBlankIcon style={{ marginRight: "10px" }}/>
          }
        >
          {translate("ticketStatus")}
        </Button>
        <Button 
          sx={{
            color: "#fc7f04",
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            lineHeight: 1,
          }}
          onClick={() => setReturnMoney((prev) => !prev)}
          startIcon={
            returnMoney 
            ? <CheckBoxIcon style={{ marginRight: "10px" }}/>
            : <CheckBoxOutlineBlankIcon style={{ marginRight: "10px" }}/>
          }
        >
          {translate("returnMoney")}
        </Button>
        <Button 
          sx={{
            color: "#fc7f04",
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            lineHeight: 1,
          }}
          onClick={() => setSendSms((prev) => !prev)}
          startIcon={
            sendSms 
            ? <CheckBoxIcon style={{ marginRight: "10px" }}/>
            : <CheckBoxOutlineBlankIcon style={{ marginRight: "10px" }}/>
          }
        >
          {translate("sendSms")}
        </Button>
        <Button 
          sx={{
            color: "#fc7f04",
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            lineHeight: 1,
          }}
          onClick={() => setGenerateDocs((prev) => !prev)}
          startIcon={
            generateDocs 
            ? <CheckBoxIcon style={{ marginRight: "10px" }}/>
            : <CheckBoxOutlineBlankIcon style={{ marginRight: "10px" }}/>
          }
        >
          {translate("yeshInvoiceDocs")}
        </Button>
        <Button 
          sx={{
            color: "#fc7f04",
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            lineHeight: 1,
          }}
          onClick={() => setFullReturn((prev) => !prev)}
          startIcon={
            fullReturn 
            ? <CheckBoxIcon style={{ marginRight: "10px" }}/>
            : <CheckBoxOutlineBlankIcon style={{ marginRight: "10px" }}/>
          }
        >
          {translate("fullReturn")}
        </Button>
        {guestDetails?.list?.some?.((item: any) => item?.isNeedToAdditionalConfirm) ? (
          <Box padding={1} border='1px solid #d32f2f' borderRadius={2} width={1} display="flex" flexDirection='column' gap={1}>
            <Typography color='error' fontWeight='bold'>
              {intl.formatMessage({ id: 'warningCancel' })}
            </Typography>
            <FormControlLabel control={<Checkbox checked={isConfirmOverdraftCancel} color='warning' />} label={intl.formatMessage({ id: 'warningCancelCheckbox' })} onChange={() => setIsConfirmOverdraftCancel((prev) => !prev)} />
          </Box>
        ) : null}
        <Button
          size="large"
          variant="contained"
          color="warning"
          fullWidth
          disabled={!ids.length || (guestDetails?.list?.some?.((item: any) => item?.isNeedToAdditionalConfirm) && !isConfirmOverdraftCancel)}
          onClick={handleChangeTickets}
        >
          {translate("changeTicketStatus")}
        </Button>
        <Button 
          size="large"
          variant="contained"
          color="warning"
          fullWidth
          onClick={handleBackToList}
        >
          {translate("backToList")}
        </Button>
      </Box>
    );
  };

  return (
    <Modal
      title={translate("cancelTicketModalTitle")}
      visible={visible === "open"}
      style={{ maxWidth: "500px" }}
      setVisible={onCloseModal}
    >
      {view === 'search' ? searchView() : null}
      {view === 'list' ? listView() : null}
      {view === 'item' ? itemView() : null}
    </Modal>
  );
}
